import Axios from "axios";

export const axiosInstance = Axios.create();

export default axiosInstance;
